module.exports = " <div class=btn-group data-toggle=buttons> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ui/checkbox-group.vue
// module id = 223
// module chunks = 0